export const css = {
	root: '_3B_tDODs',
	' _key': 'apic-theme/apic/variants/mqual1'
};

export default css;
